import Icon from '@material-ui/icons/ChevronRight'
import * as moment from 'moment'
import * as React from 'react'

import './style.scss'

interface IProps {
  action?: any
  iterator?: number
  label?: string
  date?: number
  isLink?: boolean
  report?: any
  isReport?: boolean
}

export class WhiteLink extends React.Component<IProps> {
  render() {
    const {
      action,
      iterator,
      label,
      date,
      isLink,
      report,
      isReport
    } = this.props

    if (!isLink) {
      return (
        <div
          className="whitelink"
          onClick={() => {
            action(iterator)
          }}
        >
          <div className="whitelink-text">
            {label}
            <p>Details</p>
          </div>
          <div className="whitelink-icon">
            <Icon />
          </div>
        </div>
      )
    } else if (!isReport) {
      return (
        <div
          className="whitelink"
          onClick={() => {
            action(report)
          }}
        >
          <div className="whitelink-text">{date ? date : null}</div>
          <div className="whitelink-icon">
            <Icon />
          </div>
        </div>
      )
    } else {
      return (
        <div
          className={`whitelink ${isReport ? 'report' : ''}`}
          onClick={() => {
            action(report)
          }}
        >
          <div className="whitelink-text">
            {report.date
              ? moment(report.date * 1000).format('MMMM Do, YYYY')
              : null}
          </div>
          <div className="whitelink-icon">
            <Icon />
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/WhiteLink/index.tsx